import { QpNgxQimaDateService } from '@library/services/qp-ngx-qima-date/qp-ngx-qima-date.service';

/**
 * @returns {qpNgxQimaDateFactory} The date factory for ngx-qima
 */
export function qpNgxQimaDateFactory(): QpNgxQimaDateService {
  return new QpNgxQimaDateService();
}
